const stringScissors = (text, length=50, startIndex=0) => {
    if (text?.length < length || typeof text != 'string') return text
    return text?.slice(startIndex, length) + '...'
}
export {stringScissors};